/* eslint-disable no-undef */

import React, {Component} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import Dropzone from 'react-dropzone-uploader'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {removeUploadedFile} from "../../../api";
import { Grid, FormHelperText } from '@material-ui/core';

const styles = theme => ({
    root: {},
    uploadIcon: {
        marginRight: 12,
        marginLeft: -4
    },
    uploadIconSm: {
        marginRight: 8,
        marginLeft: -8
    },
    uploadedInvoicesWrapper: {
        marginTop: 16,
        textAlign: 'center',
    },
    uploadedInvoicesTitle: {
        fontWeight: 500
    },
    uploadedInvoice: {},
    errorText: {
        marginTop: theme.spacing(2),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important',
    },
});

class UploadQuestion extends Component {
    state = {
        uploadValues: [],
        showUploads: false,
    }

    componentDidMount() {
        if (this.props.value) {
            this.initUploadValues(this.props.value)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.initUploadValues(nextProps.value)
        }
    }

    initUploadValues(values) {
        this.setState({uploadValues: values.map(String)})
    }

    handleChange = (value, checked = null) => {
        if (checked !== null) {
            let uploadValues = this.state.uploadValues
            if (checked === false) {
                uploadValues = uploadValues.filter(x => x !== value)
            } else {
                uploadValues.push(value)
            }
            this.setState({uploadValues: uploadValues})
            value = uploadValues
        }
        this.props.onValueChanged(this.props.question.id, value)
    };

    toggleShowUploads = () => {
        this.setState({showUploads: !this.state.showUploads})
    }

    getUploadParams = ({file, meta}) => {
        this.handleChange(meta.id, true)

        const {question, visitorSessionId} = this.props;

        const body = new FormData()
        body.append('file', file)
        body.append('fileId', meta.id)
        body.append('visitorSessionId', visitorSessionId)
        body.append('type', question.name)
        return {url: process.env.MIX_API_URL + '/aq/upload', body}
    }

    handleChangeStatus = ({meta, file}, status) => {
        if (status === 'removed') {
            this.handleChange(meta.id, false)

            removeUploadedFile(this.props.visitorSessionId, meta.id).then(() => {
            }).catch((err) => alert(err))
        }
    }

    render() {
        const {showUploads} = this.state;
        const {classes, question, value, visitorSessionId} = this.props;

        return (
            <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)}
                  className={classes.root}>
                <Dropzone
                    getUploadParams={this.getUploadParams}
                    onChangeStatus={this.handleChangeStatus}
                    inputContent={<><FontAwesomeIcon size={'lg'} icon={['fal', 'upload']}
                                                     className={classes.uploadIcon}/> {question.title} {value && value.length > 0 && 'lisää'}</>}
                    inputWithFilesContent={<><FontAwesomeIcon size={'lg'} icon={['fal', 'upload']}
                                                              className={classes.uploadIconSm}/> Lataa lisää </>}
                />
                {value && value.length > 0 &&
                <div className={classes.uploadedInvoicesWrapper}>
                    <div className={classes.uploadedInvoicesTitle}>{value.length} kpl ladattuja tiedostoja. <a href="#"
                                                                                                               onClick={this.toggleShowUploads}> {!showUploads ? 'Näytä' : 'Piilota'}</a>
                    </div>
                    {showUploads && value.map((invoiceKey, key) => <div className={classes.uploadedInvoice} key={key}>
                        <a target="_blank"
                           href={process.env.MIX_API_URL + '/aq/upload?vs=' + visitorSessionId + '&key=' + invoiceKey}>{invoiceKey}</a>
                    </div>)}
                </div>
                }
                {question.valid === false &&
                <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}><FormHelperText
                    className={classes.errorText}>{question.errorMessage}</FormHelperText></Grid>}
            </Grid>
        )
    }
}

export default withStyles(styles)(UploadQuestion);
